import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import I18n from "^/config/i18n";
import sortOptions from "./sortOptions";

function FilterForm({
  lang,
  updateOrder,
  updateSearch,
  updateCategory,
  filter,
  categories,
  currentValues,
}) {
  const localizedFilter = [
    { key: "", de: "Alle Kategorien", en: "All categories" },
    ...categories.filter((item) => filter.indexOf(item.key) !== -1),
  ];

  return (
    <div>
      <h4 className="mt-0 mb-2 p-0">{I18n.t("Filter")}</h4>
      <Form>
        <Label for="searchTerm" className="mt-3 mb-2 font-weight-bold">
          {I18n.t("Blog search by keyword")}
        </Label>
        <div className="d-flex">
          <FormGroup className="m-0">
            <Input
              type="text"
              name="q"
              className="m-0"
              id="searchTerm"
              placeholder={I18n.t("Blog enter keyword")}
              onChange={updateSearch}
              value={currentValues.q}
            />
          </FormGroup>
          <Button color="secondary" className="ms-2 h-100">
            {I18n.t("General btn search")}
          </Button>
        </div>
        <FormGroup className="m-0">
          <Label for="filter-categories" className="mt-3 mb-2 font-weight-bold">
            {I18n.t("Blog filter by category")}
          </Label>
          <Input
            type="select"
            name="category"
            id="filter-categories"
            onChange={updateCategory}
            value={currentValues.category}
          >
            {localizedFilter.map((elem, index) => (
              <option value={elem.key} key={index}>
                {elem[lang]}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className="m-0">
          <Label for="filter-sort" className="mt-3 mb-2 font-weight-bold">
            {I18n.t("sort by")}
          </Label>
          <Input
            type="select"
            name="order"
            id="filter-sort"
            onChange={updateOrder}
            value={currentValues.order}
          >
            {sortOptions(lang).map((elem, index) => (
              <option value={elem.value} key={index}>
                {elem.key}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Form>
      <hr />
    </div>
  );
}

export default FilterForm;
